<template>
	<template v-if="templateData && templateData.post">
		<StepperComponent 
			:templateData="templateData" 
			/>

	</template>

	
			  <!-- <div><img src="http://placehold.it/2000x1000" alt=""></div>
			  <div><img src="http://placehold.it/2000x1000" alt=""></div>
			  <div><img src="http://placehold.it/2000x1000" alt=""></div>
			  <div><img src="http://placehold.it/2000x1000" alt=""></div>
			  <div><img src="http://placehold.it/2000x1000" alt=""></div> -->
			
</template>


<script>

import StepperComponent from '@vueapp/components/StepperComponent.vue'

export default {
	name: 'StepperView',
	props: ['postSlug', 'postId'],
	components: {
		StepperComponent,
	},
	data() {
		return {
			templateData: {},
			settings: {
				"dots": true,
				"focusOnSelect": true,
				"infinite": true,
				"speed": 500,
				"slidesToShow": 3,
				"slidesToScroll": 3,
				"touchThreshold": 5
			}
		}
	},
	provide() {
		// if ( this.templateData.post ) {
			return {
				stepperViewId: true
			}
		// }	
	},
	methods: {

	},
	computed: {
		
	},
	created() {
		console.log('StepperView created')
	},
	async beforeMount() {

		const params = new URLSearchParams(window.location.search),
            eParams = {}
        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+]+)$/) ) {
                eParams[name] = value
            }
        });

        let paramsString = ( new URLSearchParams(eParams) ) .toString()

		// console.log(BRYTER.homeUrl + '/data-view/' + this.postSlug + '/?env=' + BRYTER.envId + '&json')
	    fetch( BRYTER.homeUrl + '/stepper/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
      		.then(response => response.json())
      		.then(data => {
      			// console.log(data)
        		this.templateData = data
        		// this.loading = false
        		
      		})

	}
}	
</script>

<style scoped>

.n-carousel .n-carousel__slides .n-carousel__slide {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
}
</style>